import { LoadingCard } from '@/components/Base/LoadingCard/LoadingCard'
import { NoDataToDisplayCard } from '@/components/Base/NoDataToDisplayCard/NoDataToDisplayCard'
import { useAppSelector } from '@/hooks/use-app-selector'
import { IRvAttributionBySectorDTO } from '@/interfaces/rvReport.interface'
import { getAttributionBySector } from '@/services/axiomReport.service'
import { getTop11AttributionBySector } from '@/utils/tableGridUtils'
import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { RVAttributionBySectorChart } from './AttributionBySectorChart'
import { AttributionBySectorTable } from './AttributionBySectorTable'

export const AttributionBySectorRootComponent: React.FC<{
  setGridReference: Function
}> = ({ setGridReference }) => {
  const selectedReport = useAppSelector((s) => s.axiomReport.selectedReport)
  const [rowData, setRowData] = useState<IRvAttributionBySectorDTO[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchAttributionBySector = async () => {
      try {
        setLoading(true)
        const response = await getAttributionBySector(selectedReport.reportId)
        if (response && response.length) {
          let transformedData = response
          if (transformedData.length > 11) {
            transformedData = getTop11AttributionBySector(
              response,
              'port_total_return_contrib',
            )
          }
          setRowData(transformedData)
        }
      } catch (err) {
        console.warn(err)
      } finally {
        setLoading(false)
      }
    }
    if (Object.keys(selectedReport).length) {
      fetchAttributionBySector()
    }
  }, [selectedReport])

  if (loading) {
    return <LoadingCard />
  } else if (rowData.length) {
    return (
      <Box
        display='grid'
        height='100%'
        gridTemplateRows='repeat(2, auto)'
        gap={4}
        boxSizing='border-box'
        pt={0}
      >
        <RVAttributionBySectorChart chartData={rowData} />
        <AttributionBySectorTable
          rowData={rowData}
          setGridReference={setGridReference}
        />
      </Box>
    )
  } else {
    return <NoDataToDisplayCard />
  }
}
